import { Modal } from "rsuite";
import { Button } from "reactstrap";
const PendingApprovalModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal open={open} size="xs" onClose={onClose}>
      <div className="modal-header">
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div
        className="modal-body pb-2 pt-0"
        style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}
      >
        <div className=" text-center">
          <i className="mdi mdi-update text-primary" style={{ fontSize: 35 }} />
          <h5 className="modal-title mb-3">Account Pending Approval</h5>
        </div>
        Thank you for registering! Your account is pending approval. You will be
        notified via email once it is ready for use.
      </div>
      <div className="modal-footer pt-2">
        <Button
          color="primary"
          type="submit"
          disabled={false}
          onClick={() => {
            window.open("mailto:support@growthcloud.com");
          }}
          className="mx-auto"
        >
          Contact Support
        </Button>
      </div>
    </Modal>
  );
};

export default PendingApprovalModal;
